
// pages/product-by-health-interest html code

$(document).ready(function(){
  $.ajax({
    url: "/pages/product-by-health-interest-html-page",
    datatype: "html",
    
    error: function(data){
    console.log(data);
    },
    success: function(data){
//       $('.allother-collection-append').hide();
      var html = $(data).find('.allother-linklist-collections');
      $(".allother-collection-append").html(html);
      

      var second_html1 = $(data).find('.allother-linklist-collections-5');
      $(".allother-collection-append").append(second_html1);

      
      
      var second_html2 = $(data).find('.allother-linklist-collections-6');
         $(".allother-collection-append").append(second_html2);
      
      
      var third_html = $(data).find('.allother-linklist-collections-7-to-8');
         $(".allother-collection-append").append(third_html);
      
      var fourth_html = $(data).find('.allother-linklist-collections-9-to-10');
         $(".allother-collection-append").append(fourth_html);
      

      var fifth_html = $(data).find('.allother-linklist-collections-11-to-12');
      $(".allother-collection-append").append(fourth_html);

      var Sixth_html = $(data).find('.allother-linklist-collections-13-to-14');
      $(".allother-collection-append").append(Sixth_html);
      
      $('#waitloader').hide();
      
//       setTimeout(function() { 
// //           $('#waitloader').hide();
//           $('.allother-collection-append').show(); 
//       }, 200); 
      
      // Configure/customize these variables.
    var showChar = 40;  // How many characters are shown by default
    var ellipsestext = "...";
    var moretext = "Show more >";
    var lesstext = "Show less";

      $('.allother-collection-append .more').each(function() {
        var content = $(this).html();

        if(content.length > showChar) {

          var c = content.substr(0, showChar);
          var h = content.substr(showChar, content.length - showChar);

          var html = c + '<span class="moreellipses">' + ellipsestext+ '&nbsp;</span><span class="morecontent"><span>' + h + '</span>&nbsp;&nbsp;<a href="" class="morelink">' + moretext + '</a></span>';

          $(this).html(html);
        }

      });

      $(".allother-collection-append .morelink").click(function(){
        if($(this).hasClass("less")) {
          $('.cuank').css("height", "40px");
          $('.collection-product .title').css("height", "40px");
          $(this).removeClass("less");
          $(this).html(moretext);
        } else {
          $('.cuank').css("height", "100%");
          $('.collection-product .title').css("height", "100%");
          $(this).addClass("less");
          $(this).html(lesstext);
        }
        $(this).parent().prev().toggle();
        $(this).prev().toggle();
        return false;
      });
    },
      complete: function() {
//         $('#waitloader').hide();
      }
  });

  
  $('.customselect-box-custom-link-list').change(function(){
  var select_value =   $(this).val();
    console.log(select_value);
    var newurl = 'https://longevitypremier.com'+select_value;
    $(location).attr('href',newurl);
  });
});



$(document).ready(function(){
  setTimeout(function(){ 
    $('#shopify-section-product-template .pricing').show();
  }, 6000);
//   tabs
 if( jQuery(".qa-wrapper .question-wrapper").hasClass('active') ){
		jQuery(".qa-wrapper .question-wrapper.active").closest('.qa-wrapper').find('.answer-wrapper').show();
	}
	jQuery(".qa-wrapper .question-wrapper").click(function(){
     
		if( jQuery(this).hasClass('active') ){
			jQuery(this).removeClass("active").closest('.qa-wrapper').find('.answer-wrapper').slideUp(200);
          
		}
      
		else{	 jQuery(".qa-wrapper .question-wrapper").removeClass("active").closest('.qa-wrapper').find('.answer-wrapper').slideUp(200);
          jQuery(this).addClass("active").closest('.qa-wrapper').find('.answer-wrapper').slideDown(200);
             
		}
      
	}); 
  
});


// $(window).scroll(function() {
//   if ($(this).scrollTop() >= $('.indexsection-2').offset().top) {
// //     console.log('0');
//       $('#shopify-section-by_health_intrest').find('.displayhidehtml').removeClass('displayhidehtml');
//   }
// });

document.addEventListener("DOMContentLoaded", function() {
  /* 2026-10-20: only start endless scroll on pages that load Ajaxinate (collection pages); other pages used to throw "Ajaxinate is not defined" */
  if (typeof Ajaxinate === 'function' && document.getElementById('AjaxinateLoop')) {
    var endlessScroll = new Ajaxinate();
  }
});
